import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { MeetingPointer } from '../models';

@Injectable({
  providedIn: 'root'
})
export class MeetingPointerService {
  constructor(private readonly http: HttpClient) {}

  getMeetingPointers(): Observable<MeetingPointer[]> {
    return this.http.get<MeetingPointer[]>(`${environment.BACKEND_URL}/navigation/meetingpointers`);
  }
}
